<template>
<span class="input-group-text">
    <slot></slot>
</span>
</template>

<script>
export default {

}
</script>